import { render, staticRenderFns } from "./Company.yaml?vue&type=template&id=5af69b5c&component"
import script from "./Company.yaml?vue&type=script&lang=ts&component"
export * from "./Company.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports